module.exports = __webpack_public_path__ + "img/151.03a71804.jpg";